import { Injectable } from '@angular/core';
import { Usuario, Usuario2, Usuario3, UserOptions } from '../../models/usuario.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import { Perfisica, PerMoral, ContribuyenteFisica, ContribuyenteMoral, DocumentoPropiedad } from '../../models/personas.model';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';

@Injectable()
export class ContribuyentesService {

  usuario: Usuario;
  token: string;
  usuario2: Usuario2;
  idUsuario: string;

  constructor(
    public http: HttpClient,
    public router: Router
  ) {
    this.cargarStorage();
  }

  cargarStorage() {

    if ( localStorage.getItem('tkn')) {
      this.token = localStorage.getItem('tkn');
      this.usuario = JSON.parse( localStorage.getItem('usuario') );
    } else {
      this.token = '';
      this.usuario = null;
    }

  }


  crearPersonaFisica( params ) {

    params.token = this.token;
    params.secret_key = environment.SECRET_KEY;

    const url = `${environment.URL_SERVICIOS}/people/`;


    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return this.crearArregloPersonaFisica(resp);
              }));
  }

  crearArregloPersonaFisica( usuariosObj: any) {

    const usuarios: any[] = [];
    const resul: any[] = [];

    if ( usuariosObj === null ) { return []; }
    Object.keys ( usuariosObj ).forEach( key => {
      const usuario: any = usuariosObj[key];
      usuarios.push( usuario );
    });
    // tslint:disable-next-line: forin
    resul.push( usuarios[0].attributes );

    return resul;

}

  crearContribuyenteFisica( contribuyentefisica: ContribuyenteFisica, idf: any ) {

    const url = `${environment.URL_SERVICIOS}/contributors?contributor[contributor_type]=${contribuyentefisica.tipo}&contributor[bank]=${contribuyentefisica.banco}
                &contributor[account_number]=${contribuyentefisica.ncuentafisica}&contributor[clabe]=${contribuyentefisica.clabefisica}
                &contributor[extra1]=${contribuyentefisica.cbfisica}&contributor[person_id]=${idf}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;


    return this.http.post( url, null ).pipe(
              map( (resp: any) => {
                return resp.data.attributes.id;
              }));
  }

  crearPersonaMoral( params ) {

    params.token = this.token;
    params.secret_key = environment.SECRET_KEY;

    const url = `${environment.URL_SERVICIOS}/legal_entities/`;


    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return this.crearArregloPersonaMoral(resp);
              }));
  }

  crearArregloPersonaMoral( usuariosObj: any) {

    const usuarios: any[] = [];
    const resul: any[] = [];

    if ( usuariosObj === null ) { return []; }
    Object.keys ( usuariosObj ).forEach( key => {
      const usuario: any = usuariosObj[key];
      usuarios.push( usuario );
    });
    // tslint:disable-next-line: forin
  //  console.log( usuarios[0][prop].attributes );
    resul.push( usuarios[0].attributes );

    return resul;

}

crearContribuyenteMoral( contribuyentemoral: ContribuyenteMoral, idm: any ) { 

  const url = `${environment.URL_SERVICIOS}/contributors?contributor[contributor_type]=${contribuyentemoral.tipo}&contributor[bank]=${contribuyentemoral.banco}
              &contributor[account_number]=${contribuyentemoral.ncuentamoral}&contributor[clabe]=${contribuyentemoral.clabemoral}
              &contributor[extra1]=${contribuyentemoral.cbmoral}&contributor[legal_entity_id]=${idm}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;


  return this.http.post( url, null ).pipe(
            map( (resp: any) => {
              return resp.data.attributes.id;
            }));
}

getContribuyentes() {

  const url = `${environment.URL_SERVICIOS}/contributors?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );

}

getContribuyentesPorId(id) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

crearArregloContribuyente( contribuObj: any) {

  const contribuyentes: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
 /* Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    contribuyentes.push( rol );
  }); */
  // tslint:disable-next-line: forin
  for (const prop in contribuObj.data) {
  resul.push( contribuObj.data[prop].attributes );
  }

  return resul;

}

getPersonaFisica( idf: string ) {

  const url = `${environment.URL_SERVICIOS}/people/${idf}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArreglopf(resp);
    } )
  );

}

crearArreglopf( contribuObj: any) {

  const contribuyentes: any[] = [];
  const resul: any[] = [];

  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    contribuyentes.push( rol );
  });
  // tslint:disable-next-line: forin

//  console.log( usuarios[0][prop].attributes );
  resul.push( contribuyentes[0].attributes );


 // console.log(resul);

  return resul;

}

crearDP( id, params ) {

params.token = this.token;
params.secret_key = environment.SECRET_KEY;

const url = `${environment.URL_SERVICIOS}/contributors/${id}/property_documents`;

return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp.data.attributes.id;
              }));
}

// LISTAS

getFiscalRegime() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 

  const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_FISCAL_REGIME`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanySegmentsCurrency() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 

  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_SEGMENTS_CURRENCY`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getAdresstype() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/CONTRIBUTOR_ADDRESS_ADDRESS_TYPE`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getAsentamientotype() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/CONTRIBUTOR_ADDRESS_SUBURB_TYPE`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getPersonGender() {

  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_GENDER`;

  return this.http.post(url, params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getPersonFiscalRegime() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/PEOPLE_FISCAL_REGIME`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getLegalEntityFiscalRegime() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/LEGAL_ENTITIES_FISCAL_REGIME`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanySector() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_SECTOR`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanySubSector() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_SUBSECTOR`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getSupplierSector() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/SUPPLIER_SECTOR`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getSupplierSubSector() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/SUPPLIER_SUBSECTOR`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getMaritalStatusFisica() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/PEOPLE_MARTIAL_STATUS`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getTipoIdentificacionFisica() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/PEOPLE_ID_TYPE`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getParentezco() {
  const params = new HttpParams () 
	.set ('token', this.token)
	.set ('secret_key', environment.SECRET_KEY); 
  const url = `${environment.URL_SERVICIOS}/lists/domain/SIGNATORIES_PARTNERSHIP`;

  return this.http.post(url,params).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

crearArregloList( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];

  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes.value );

  }

  return resul;

}

getFirmantes() {

  const url = `${environment.URL_SERVICIOS}/reports/signatories?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

getContribuyentesMain() {

  const url = `${environment.URL_SERVICIOS}/reports/contributors_main?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

// CYP

getCadenaxcontribuyente(id) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/companies?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloCadena(resp);
    } )
  );

}

get_contributor_register(id) {

  const url = `${environment.URL_SERVICIOS}/get_contributor_registers/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url)
  // .pipe(
  //   map( (resp: any) => {
  //     return this.crearArregloCadena(resp);
  //   } )
  // );

}

getCustomerxcontribuyente(id) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/customers?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloCadena(resp);
    } )
  );

}

crearArregloCadena( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes );

  }

  return resul;

}

actualizaCadenaxContributente( idcont, idcompany, params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/contributors/${idcont}/companies/${idcompany}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));

}


creaCadenaxContribuyente( id, params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/companies`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

creaProveedorxContribuyente( id, params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/suppliers`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getProveedorxContribuyente(id) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/suppliers?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloProveedor(resp);
    } )
  );

}

crearArregloProveedor( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes );

  }

  return resul;

}

actualizaProveedorxContributente( idcont, idcompany, params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/contributors/${idcont}/suppliers/${idcompany}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));

}

getCompanySegments( idc ) {

  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );

}

guardaSegmento( idc, params ) {
  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;
  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments`;
  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

borraSegmento( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments/${ids}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

actualizaSegmento( idc, ids, params ) {
  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;
  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments/${ids}`;
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

creaUsdSegment( id, params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/suppliers/${id}/usd_supplier_segments`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

creaSegment( id, params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/suppliers/${id}/supplier_segments`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getUsdSegment( ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/usd_supplier_segments?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
}

getSegment( ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/supplier_segments?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
}

patchUsdSegment( ids, idsegment, params ) {
  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/usd_supplier_segments/${idsegment}/`;
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

patchSegment( ids, idsegment, params ) {
  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/supplier_segments/${idsegment}/`;
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

borraSegmentoSeg( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${idc}/supplier_segments/${ids}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

borraSegmentoUsd( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${idc}/usd_supplier_segments/${ids}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

// DIRECCIONES

getCountries() {

  const url = `${environment.URL_SERVICIOS}/countries?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

getStates() {

  const url = `${environment.URL_SERVICIOS}/countries/2047a0ba-b710-4845-9569-32b23f460977/states?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

getStatesById(id) {

  const url = `${environment.URL_SERVICIOS}/countries/${id}/states?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

getMunicipios( idm ) {

  const url = `${environment.URL_SERVICIOS}/states/${idm}/municipalities?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

getColoniasxcp( cp ) {

  const url = `${environment.URL_SERVICIOS}/postal_codes/pc/${cp}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

crearArregloStates( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes );

  }

  return resul;

}

creaFirmantexContribuyente( idc , params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/contributors/${idc}/signatories`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

creaDireccionxContribuyente( idc , params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_addresses`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getCompanySuplierProjects( ids ) {

  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/supplier_projects?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );

}

// SUPLIER PROYECTOS //////////////////////////////////////////////////////////
getCompanyProject(idcompany, idcompanyproject) {
  const url = `${environment.URL_SERVICIOS}/companies/${idcompany}/company_projects/${idcompanyproject}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

getCadenas() {

  const url = `${environment.URL_SERVICIOS}/reports/payment_companies?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => {
      return resp;
    }
    )
  );

}

getCompanyProjects(idcompany) {
  const url = `${environment.URL_SERVICIOS}/companies/${idcompany}/company_projects?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
}

guardaProyecto(params) {
  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;
  const url = `${environment.URL_SERVICIOS}/suppliers/${params.suplier_id}/supplier_projects`;
  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

actualizaProyecto(params) {
  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/suppliers/${params.suplier_id}/supplier_projects/${params.id}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));
}

borraProyecto( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${idc}/supplier_projects/${ids}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

getProjectName( idp ) {
  const url = `${environment.URL_SERVICIOS}/company_projects/${idp}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

getcompany(idc) {
const url = `${environment.URL_SERVICIOS}/companies/${idc}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;
return this.http.get(url).pipe(
  map( (resp: any) => {
    return (resp);
  } )
);
}

actualizarEmpleadoCadena(tipo: string, id: string, data){
  const url = `${environment.URL_SERVICIOS}/contributors/${id}/${tipo}/${data.id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.patch(url, data).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

company_update(data){
  const url = `${environment.URL_SERVICIOS}/company_update/company_update_info?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.patch(url, data).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}

eliminarEmpleadoCadena(tipo: string, contributor_id: string, id:string){
  const url = `${environment.URL_SERVICIOS}/contributors/${contributor_id}/${tipo}/${id}?token=${this.token}&secret_key=${environment.SECRET_KEY}`;

  return this.http.delete(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );
}



//PARA EL REGISTRO GRANDE////////////////////////////////////////////////////////

CreaPFCustomer(paramsPerson, paramsContributor, paramsContributorAdsress, paramsCustomer, tipo) {

  const params = new HttpParams()
  .set('person', 'PageNo')
  .set('person', 'SortOn');
  
  if (tipo === 'funder') {
    const url = 
    `${environment.URL_SERVICIOS}/user_registration?person[fiscal_regime]=${paramsPerson.fiscal_regime}&person[rfc]=${paramsPerson.rfc}&person[curp]=${paramsPerson.curp}&person[imss]=${paramsPerson.imss}&person[first_name]=${paramsPerson.first_name}&person[last_name]=${paramsPerson.last_name}&person[second_last_name]=${paramsPerson.second_last_name}&person[gender]=${paramsPerson.gender}&person[nationality]=${paramsPerson.nationality}&person[birth_country]=${paramsPerson.birth_country}&person[birthplace]=${paramsPerson.birthplace}&person[birthdate]=${paramsPerson.birthdate}&person[martial_status]=${paramsPerson.martial_status}&person[id_type]=${paramsPerson.id_type}&person[identification]=${paramsPerson.identification}&person[phone]=${paramsPerson.phone}&person[mobile]=${paramsPerson.mobile}&person[email]=${paramsPerson.email}&contributor[contributor_type]=${paramsContributor.contributor_type}&contributor[bank]=${paramsContributor.bank}&contributor[account_number]=${paramsContributor.account_number}&contributor[clabe]=${paramsContributor.clabe}&contributor_address[municipality_id]=${paramsContributorAdsress.municipality_id}&contributor_address[state_id]=${paramsContributorAdsress.state_id}&contributor_address[address_type]=${paramsContributorAdsress.address_type}&contributor_address[street]=${paramsContributorAdsress.street}&contributor_address[external_number]=${paramsContributorAdsress.external_number}&contributor_address[apartment_number]=${paramsContributorAdsress.apartment_number}&contributor_address[suburb_type]=${paramsContributorAdsress.suburb_type}&contributor_address[suburb]=${paramsContributorAdsress.suburb}&contributor_address[postal_code]=${paramsContributorAdsress.postal_code}&contributor_address[address_reference]=${paramsContributorAdsress.address_reference}&funder[funder_type]=FF1&funder[name]=${paramsCustomer.name}&funder[status]=${paramsCustomer.status}&funder[attached]=${paramsCustomer.attached}&funder[user_id]=${paramsCustomer.user_id}&type=${tipo}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.post(url,null).pipe(
      map( (resp: any) => {
        return (resp);
      } )
    );
  } else if ( tipo === 'customer' ) {
    const url = 
    `${environment.URL_SERVICIOS}/user_registration?person[fiscal_regime]=${paramsPerson.fiscal_regime}&person[rfc]=${paramsPerson.rfc}&person[curp]=${paramsPerson.curp}&person[imss]=${paramsPerson.imss}&person[first_name]=${paramsPerson.first_name}&person[last_name]=${paramsPerson.last_name}&person[second_last_name]=${paramsPerson.second_last_name}&person[gender]=${paramsPerson.gender}&person[nationality]=${paramsPerson.nationality}&person[birth_country]=${paramsPerson.birth_country}&person[birthplace]=${paramsPerson.birthplace}&person[birthdate]=${paramsPerson.birthdate}&person[martial_status]=${paramsPerson.martial_status}&person[id_type]=${paramsPerson.id_type}&person[identification]=${paramsPerson.identification}&person[phone]=${paramsPerson.phone}&person[mobile]=${paramsPerson.mobile}&person[email]=${paramsPerson.email}&contributor[contributor_type]=${paramsContributor.contributor_type}&contributor[bank]=${paramsContributor.bank}&contributor[account_number]=${paramsContributor.account_number}&contributor[clabe]=${paramsContributor.clabe}&contributor_address[municipality_id]=${paramsContributorAdsress.municipality_id}&contributor_address[state_id]=${paramsContributorAdsress.state_id}&contributor_address[address_type]=${paramsContributorAdsress.address_type}&contributor_address[street]=${paramsContributorAdsress.street}&contributor_address[external_number]=${paramsContributorAdsress.external_number}&contributor_address[apartment_number]=${paramsContributorAdsress.apartment_number}&contributor_address[suburb_type]=${paramsContributorAdsress.suburb_type}&contributor_address[suburb]=${paramsContributorAdsress.suburb}&contributor_address[postal_code]=${paramsContributorAdsress.postal_code}&contributor_address[address_reference]=${paramsContributorAdsress.address_reference}&customer[customer_type]=CF1&customer[name]=${paramsCustomer.name}&customer[status]=${paramsCustomer.status}&customer[attached]=${paramsCustomer.attached}&customer[user_id]=${paramsCustomer.user_id}&type=${tipo}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.post(url,null).pipe(
      map( (resp: any) => {
        return (resp);
      } )
    );
  }
  
  
}

CreaPMCustomer(paramsPerson, paramsContributor, paramsContributorAdsress, paramsCustomer, tipo) {

  const params = new HttpParams()
  .set('person', 'PageNo')
  .set('person', 'SortOn');

  if (tipo === 'funder') {
    const url =
    `${environment.URL_SERVICIOS}/user_registration?legal_entity[fiscal_regime]=${paramsPerson.fiscal_regime}&legal_entity[rfc]=${paramsPerson.rfc}&legal_entity[rug]=${paramsPerson.rug}&legal_entity[business_name]=${paramsPerson.business_name}&legal_entity[phone]=${paramsPerson.phone}&legal_entity[mobile]=${paramsPerson.mobile}&legal_entity[email]=${paramsPerson.email}&legal_entity[business_email]=${paramsPerson.business_email}&contributor[contributor_type]=${paramsContributor.contributor_type}&contributor[bank]=${paramsContributor.bank}&contributor[account_number]=${paramsContributor.account_number}&contributor[clabe]=${paramsContributor.clabe}&contributor_address[municipality_id]=${paramsContributorAdsress.municipality_id}&contributor_address[state_id]=${paramsContributorAdsress.state_id}&contributor_address[address_type]=${paramsContributorAdsress.address_type}&contributor_address[street]=${paramsContributorAdsress.street}&contributor_address[external_number]=${paramsContributorAdsress.external_number}&contributor_address[apartment_number]=${paramsContributorAdsress.apartment_number}&contributor_address[suburb_type]=${paramsContributorAdsress.suburb_type}&contributor_address[suburb]=${paramsContributorAdsress.suburb}&contributor_address[postal_code]=${paramsContributorAdsress.postal_code}&contributor_address[address_reference]=${paramsContributorAdsress.address_reference}&funder[funder_type]=FF1&funder[name]=${paramsCustomer.name}&funder[status]=${paramsCustomer.status}&funder[attached]=${paramsCustomer.attached}&funder[user_id]=${paramsCustomer.user_id}&type=${tipo}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.post(url,null).pipe(
      map( (resp: any) => {
        return (resp);
      } )
    );
  } else if (tipo === 'customer') {
    const url = 
    `${environment.URL_SERVICIOS}/user_registration?legal_entity[fiscal_regime]=${paramsPerson.fiscal_regime}&legal_entity[rfc]=${paramsPerson.rfc}&legal_entity[rug]=${paramsPerson.rug}&legal_entity[business_name]=${paramsPerson.business_name}&legal_entity[phone]=${paramsPerson.phone}&legal_entity[mobile]=${paramsPerson.mobile}&legal_entity[email]=${paramsPerson.email}&legal_entity[business_email]=${paramsPerson.business_email}&contributor[contributor_type]=${paramsContributor.contributor_type}&contributor[bank]=${paramsContributor.bank}&contributor[account_number]=${paramsContributor.account_number}&contributor[clabe]=${paramsContributor.clabe}&contributor_address[municipality_id]=${paramsContributorAdsress.municipality_id}&contributor_address[state_id]=${paramsContributorAdsress.state_id}&contributor_address[address_type]=${paramsContributorAdsress.address_type}&contributor_address[street]=${paramsContributorAdsress.street}&contributor_address[external_number]=${paramsContributorAdsress.external_number}&contributor_address[apartment_number]=${paramsContributorAdsress.apartment_number}&contributor_address[suburb_type]=${paramsContributorAdsress.suburb_type}&contributor_address[suburb]=${paramsContributorAdsress.suburb}&contributor_address[postal_code]=${paramsContributorAdsress.postal_code}&contributor_address[address_reference]=${paramsContributorAdsress.address_reference}&customer[customer_type]=CF1&customer[name]=${paramsCustomer.name}&customer[status]=${paramsCustomer.status}&customer[attached]=${paramsCustomer.attached}&customer[user_id]=${paramsCustomer.user_id}&type=${tipo}&token=${this.token}&secret_key=${environment.SECRET_KEY}`;
    return this.http.post(url,null).pipe(
      map( (resp: any) => {
        return (resp);
      } )
    );
  }
  
}

crearCadena( params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${ environment.URL_SERVICIOS }/company_registration?`; //  ?option[name]=${ name }&option[description]=${ desc }&option[group]=${ group }&option[url]=${ urlo }&token=1&secret_key=${ environment.SECRET_KEY };

  return this.http.post( url, params ).pipe(
            map( (resp: any) => {
              return resp;
            }));
}

patchCompanyInfo( params ) {

  params.token = this.token;
  params.secret_key = environment.SECRET_KEY;

  const url = `${environment.URL_SERVICIOS}/company_update/company_update_info`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));

}

getcompanyInfo(idc) {
  const url = `${environment.URL_SERVICIOS}/get_company_info?token=${this.token}&secret_key=${environment.SECRET_KEY}&company_id=${idc}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////


// LISTAS //////////



}
